import { hashString } from './hash';

export const generateContextKey = (
  organizationId: string,
  agentId: string,
  agentVariables: Record<string, unknown>
): string => {
  const hasVariables = Object.keys(agentVariables).length > 0;
  const varsString = hasVariables ? JSON.stringify(agentVariables, Object.keys(agentVariables).sort()) : '';
  const fullContext = `${organizationId}_${agentId}_${varsString}`;
  return hashString(fullContext);
};
